import { render } from "./AssignedRatingCard.vue?vue&type=template&id=0ceb268b"
import script from "./AssignedRatingCard.vue?vue&type=script&lang=ts"
export * from "./AssignedRatingCard.vue?vue&type=script&lang=ts"
script.render = render
/* custom blocks */
import block0 from "./AssignedRatingCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


export default script